// @ts-nocheck
import React, { Component } from 'react';
import { navigate } from '../../../../../lib/routerAdapter';
import { Tabs, TabItem } from '../../../../../components/ui';
import { pddTest } from '../../../../../lib/enum';
export default class HeaderTabs extends Component {
  render() {
    return <Tabs defaultTab={this.props.selectedTab}>
        {this.props.examTraining !== pddTest.exam && <TabItem tabKey="tests" label="Обучение" onClick={() => navigate(`/pdd/test/${this.props.examTraining}/tests/`)} />}
        <TabItem tabKey="results" label="Результаты" onClick={() => navigate(`/pdd/test/${this.props.examTraining}/results/`)} />
      </Tabs>;
  }
}
